import React from 'react'
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'

export const BRAND_OPTIONS = [
    { value: 'All', label: 'All brands' },
    { value: 'Carrier', label: 'Carrier' },
    { value: 'Ciat', label: 'Ciat' },
]

export default function BrandFilter({ value, onChange, id = 'rooftop-brand-filter' }) {
    return (
        <FormControl size='small' sx={{ minWidth: 160 }}>
            <InputLabel id={`${id}-label`}>Brand</InputLabel>
            <Select labelId={`${id}-label`} id={id} value={value} label='Brand' onChange={(e) => onChange(e.target.value)}>
                {BRAND_OPTIONS.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                        {option.label}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    )
}
